import React from 'react';
import {connect} from "react-redux";
import {routerActions} from "react-router-redux";
import {validated} from 'react-custom-validation'
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import clone from "clone";
import moment from 'moment';
import {CardElement, injectStripe} from "react-stripe-elements";

import {handleSelectChange} from 'utils/handle-changes';
import {PROMO_CODE_VALUES, SUBSCRIPTION_PRICES, SUBSCRIPTION_TYPES} from "../../../utils/constants";

import {putPaymentMethod, putSubscription} from "../store/actions";

import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import Form from 'components/Form';
import FormColumn from 'components/FormColumn';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import H3 from 'components/H3';
import Label from 'components/Label';
import LoadingCircle from 'components/LoadingCircle';
import Modal from 'components/Modal';

class AgencyBillingForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isGettingToken: false,
            subscriptionType: props.auth.user && props.auth.user.company ? props.auth.user.company.subscriptionType : ''
        };
    }

    handleSavePaymentMethod = async () => {
        this.setState({isGettingToken: true});
        let {token} = await this.props.stripe.createToken();
        console.log(token);
        this.props.putPaymentMethod(token.id)
            .then((res) => {
                this.setState({isGettingToken: false, showSuccessModal: true});
                this._element.clear();
            });
    };

    handleSaveSubscription = () => {
        this.props.putSubscription(this.state.subscriptionType)
            .then((res) => {
                this.setState({showSuccessModal: true})
            });
    };

    formatBillingDate(dateUnixTime) {
        return moment((dateUnixTime || new Date().getTime() / 1000) * 1000).format('h:mm a, MMM DD YYYY')
    }

    formatExpirationDate(expirationDate) {
        return moment(expirationDate || new Date()).format('MMM YYYY')
    }

    companyHasValidPaymentMethod(company) {
        return company.subscriptionCardType &&
            company.subscriptionCardLast4 &&
            company.subscriptionCardExpirationDate &&
            new Date(company.subscriptionCardExpirationDate).getTime() > new Date().getTime();
    }

    companyHasPaymentProblem(company) {
        return company.subscriptionStatus === 'past_due' || company.subscriptionStatus === 'unpaid'
    }

    renderSubscriptionSelector(company) {
        const {isSavingSubscription} = this.props.accounts;

        let options = SUBSCRIPTION_TYPES;
        if(company.signupPromoCode && SUBSCRIPTION_PRICES[company.signupPromoCode.toLowerCase()] != null) {
            options[1].label = options[1].label.replace('###PRICE###', SUBSCRIPTION_PRICES[company.signupPromoCode.toLowerCase()])
        } else {
            options[1].label = options[1].label.replace('###PRICE###', '$2500 per year')
        }

        return (
            <Form className="agency-billing-form">
                <FormRow columnCount={2}>
                    <FormColumn>
                        <Dropdown
                            id="selSubscriptionType"
                            label="Subscription Plan"
                            name="subscriptionType"
                            clearable={false}
                            onChange={handleSelectChange.bind(this, (name, value) => this.setState({subscriptionType: value}), 'subscriptionType', null, null)}
                            options={options}
                            placeholder="Choose a New Plan"
                            value={this.state.subscriptionType}
                        />
                    </FormColumn>

                    <FormColumn className="agency-billing-form__button-wrapper">
                        <Button disabled={isSavingSubscription}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.handleSaveSubscription();
                                }}
                                type="submit">
                            Save Subscription Plan
                            {isSavingSubscription ? <LoadingCircle innerColor="#ffffff" outerColor="#ffffff"/> : null}
                        </Button>
                    </FormColumn>
                </FormRow>

                {company.signupPromoCode && (
                    <p>
                        Promo Code Used: <strong>{company.signupPromoCode.toUpperCase()}</strong> {PROMO_CODE_VALUES[company.signupPromoCode.toLowerCase()] != null ? `(${PROMO_CODE_VALUES[company.signupPromoCode.toLowerCase()]})` : ''}
                    </p>
                )}
            </Form>
        )
    }

    renderPaymentForm(company) {
        const {error, isSavingPaymentMethod} = this.props.accounts;
        return (
            <Form className="agency-billing-form agency-billing-form--payment">
                {Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                {this.companyHasValidPaymentMethod(company) && (
                    <FormRow>
                        Current card: <strong>{company.subscriptionCardType} {company.subscriptionCardLast4}</strong>,
                        expires: <strong>{this.formatExpirationDate(company.subscriptionCardExpirationDate)}</strong>
                    </FormRow>
                )}

                <FormRow columnCount={2}>
                    <FormColumn>
                        <Label>Payment Method</Label>
                        <div className="stripe-wrapper">
                            <CardElement onReady={(element) => this._element = element}/>
                        </div>
                    </FormColumn>

                    <FormColumn className="agency-billing-form__button-wrapper">
                        <Button disabled={isSavingPaymentMethod || this.state.isGettingToken}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.handleSavePaymentMethod();
                                }}
                                type="submit">
                            Save Payment Method
                            {isSavingPaymentMethod || this.state.isGettingToken ?
                                <LoadingCircle innerColor="#ffffff" outerColor="#ffffff"/> : null}
                        </Button>
                    </FormColumn>
                </FormRow>
            </Form>
        )
    }

    renderForLifetimeMember() {
        return (
            <div>
                <p>You have a lifetime subscription to The Hunt! Thank you for your support.</p>
            </div>
        )
    }

    renderForSuspendedAccount(company) {
        return (
            <div>
                {this.companyHasValidPaymentMethod(company) ? (
                    <div>
                        <p>Your subscription is currently suspended. Please select a plan from the choices below:</p>
                        {this.renderSubscriptionSelector(company)}
                        {this.renderPaymentForm(company)}
                    </div>
                ) : (
                    <div>
                        <p>Your subscription is currently suspended and no payment method is on file. Please add a
                            payment method:</p>
                        {this.renderPaymentForm(company)}
                    </div>
                )}
            </div>
        )
    }

    renderForActiveAccount(company) {
        console.log(company)
        return (
            <div>
                <p>
                    Current
                    Plan: <strong>{company.subscriptionType === 'annual' ? 'Business Member' : company.subscriptionType}</strong>
                    {company.subscriptionStatus === 'trialing' && ` (Free trial until ${this.formatBillingDate(company.subscriptionTrialPeriodEnd)})`}
                </p>

                {company.subscriptionStatus !== 'trialing' && (
                    <p>
                        Next Billing
                        Date: <strong>{this.formatBillingDate(company.subscriptionBillingPeriodEnd)}</strong>
                    </p>
                )}

                {this.companyHasPaymentProblem(company) ? (
                    <div>
                        <p>We had a problem charging your card. Please update your payment method:</p>
                        {this.renderPaymentForm(company)}
                    </div>
                ) : (
                    <div>
                        {this.companyHasValidPaymentMethod(company) ? (
                            <div>
                                {this.renderSubscriptionSelector(company)}
                                {this.renderPaymentForm(company)}
                            </div>
                        ) : (
                            <div>
                                <p>You do not have a valid payment method on file. Please add a payment method:</p>
                                {this.renderPaymentForm(company)}
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    }

    renderSubscriptionForm(company) {
        if (company.isLifetimeMember) {
            return this.renderForLifetimeMember()
        } else if (company.subscriptionType === 'free') {
            return this.renderForSuspendedAccount(company)
        } else {
            return this.renderForActiveAccount(company)
        }


    }

    render() {
        let {user} = this.props.auth;
        let {company} = user;

        if (!company || Object.keys(company).length === 0 || !user || Object.keys(user).length === 0) {
            return (
                <LoadingCircle/>
            );
        } else {
            return (
                <div className="agency-billing-form-wrapper">

                    <H3>
                        Billing Information
                    </H3>

                    {this.renderSubscriptionForm(company)}

                    <Modal show={this.state.showSuccessModal === true}
                           title="Success!">
                        <p>
                            Your changes are saved.
                        </p>
                        <div className="c-modal__button-wrapper">
                            <Button onClick={() => this.setState({showSuccessModal: false})}>
                                OK
                            </Button>
                        </div>
                    </Modal>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts,
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        putPaymentMethod: (stripeToken) => dispatch(putPaymentMethod(stripeToken)),
        putSubscription: (subscriptionType) => dispatch(putSubscription(subscriptionType))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(AgencyBillingForm));



// WEBPACK FOOTER //
// ./src/containers/Accounts/Edit/AgencyBillingForm.js